import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { isSCCService } from '../../../redux/rights/selectors/roles';
import { useAppSelector } from '../../../../../redux/store.model';

export const FreshwatchRolesGuard = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isAdmin = useAppSelector(isSCCService);

  useEffect(() => {
    if (isAdmin && !pathname.includes(`/companies`)) {
      navigate(`/companies`, { replace: true });
    }
    if (!isAdmin && pathname.includes(`/companies`)) {
      navigate(`/storelist`, { replace: true });
    }
  }, [isAdmin, pathname, navigate]);

  if (pathname.includes(`/companies`)) return <Outlet />;

  return <Outlet />;
};
